import { render } from "./BaseTreeSelect.vue?vue&type=template&id=629fb1c0"
import script from "./BaseTreeSelect.vue?vue&type=script&lang=js"
export * from "./BaseTreeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__